import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap, TimelineMax} from "gsap";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class TheBorderFreeSpinIntroRunner implements SimplePresentation {

    public shouldRun(): boolean {
        return (TheBorder.model.data.mode == TheBorderGameMode.NORMAL || TheBorder.model.data.mode == TheBorderGameMode.NORMAL_AVALANCHE)
            && TheBorder.model.data.nextMode == TheBorderGameMode.FREESPIN;
    }

    public start(controller: SimplePresentationRunnerController): void {
        const mainTL: TimelineMax = gsap.timeline();

        mainTL.add(() => {
            TheBorder.isInFS = true;
            TheBorder.fsIntroView.showFSIntro(() => TheBorderFreeSpinIntroRunner.fsIntroClosedCallback(controller));

            if (TheBorder.IS_BOOSTED_BET_ON) {
                TheBorder.xRipReelHighlighter.stopHighlight();
            }
        });


        if (mainTL.duration() == 0) {
            mainTL.add(gsap.to(this, {duration: 0.001}));
        }
    }

    private static fsIntroClosedCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }
}